export default function PlayIconV2(props) {
  return (
    <svg viewBox="0 0 32.97 46.94" {...props}>
      <path
        d="M0 0l32.97 23.47L0 46.94V0z"
      />
    </svg>
  );
}
